import * as React from 'react';
import { HeadFC, Link, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { Layout } from 'components/layout';
import * as styles from './404.module.scss';

const NotFoundPage: React.FC<PageProps> = () => (
  <Layout>
    <div className={styles.genericContainer}>
      <div className={styles.imageContainer}>
        <StaticImage
          alt="404 Not Found"
          src="../images/404.png"
          placeholder="blurred"
        />
      </div>
      <div className={styles.textContainer}>
        <span className={styles.title}>Sorry, we couldn&apos;t that page</span>
        <span>Check the page address or search fot it below.</span>
        <Link to="/">Teeth Talk Girl Homepage</Link>
      </div>
    </div>
  </Layout>
);

export default NotFoundPage;

export const Head: HeadFC = () => <title>Not found</title>;
